import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store, { AppDispatch } from './redux/store';
import App from './App';
import './index.css';
import ErrorBoundary from './component/ErrorBoundary/ErrorBoundary';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './constants/variables';
import { setOnAuthFailure } from './services/tokenManager';
import { logout } from './redux/types';
import { initializeAuthFromRefresh } from './redux/actions/auth';

// Register auth failure handler to dispatch logout when token refresh fails
// This ensures Redux state is cleared and user is redirected to login
setOnAuthFailure(() => {
  store.dispatch(logout());
});

// Initialize auth on app load - check for existing refresh token
// This runs once at startup, before any routes are rendered
(store.dispatch as AppDispatch)(initializeAuthFromRefresh());

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container element with id "root" not found');
}
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <App />
        </GoogleOAuthProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
